// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1-Xmq","githubIcon":"footer_githubIcon__3UH65"};